import { NoteCategory } from '../../../../../coaching-base/general';
import { createNoteDetail } from '../../../../../coaching-note/note-detail.form';
import { Row } from '../../../../../coaching-observation/experimental.grid';
import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../commitment-narrative.action';
import {
    CellContext,
    makeRows,
    RowContext,
} from '../commitment-narrative.model';
import { State } from '../commitment-narrative.state';
import { extractText } from '../functions/html-to-text.function';

import { AddNote } from './add-note.action';

export function addNoteReducer(
    state: State,
    action: PayloadAction<ActionType, AddNote>,
): State {
    const user = action.payload.user;
    const notes = action.payload.notes ?? [];

    // Helper function to update notes and context
    const updateNotesAndContext = (
        row: Row<RowContext, CellContext>,
    ): Row<RowContext, CellContext> => {
        const updatedNotes = row.ctx.notes.map((note) => {
            const matchingNote = notes.find(
                (n) => n.trackingId === note.trackingId && n.changed,
            );
            return matchingNote != null ? matchingNote : note;
        });

        const updatedContext = extractText(updatedNotes[0]?.contents ?? '');
        return {
            ...row,
            ctx: { ...row.ctx, notes: updatedNotes, context: updatedContext },
        };
    };

    // Update contents of existing notes in rows if  changed true
    const updatedRows = state.rows.map(updateNotesAndContext);

    const updatedFilteredRows = state.filteredRow.map(updateNotesAndContext);

    let newRow = null;
    if (user != null) {
        const note = createNoteDetail(NoteCategory.GENERAL_NOTE);
        note.contents = '';
        note.createdByFirstName = user.firstName;
        note.createdByLastName = user.lastName;
        note.updatedByFirstName = user.firstName;
        note.updatedByLastName = user.lastName;
        newRow = makeRows([note])[0];
    }

    return {
        ...state,
        rows: newRow != null ? [...updatedRows, newRow] : updatedRows,
        filteredRow:
            newRow != null
                ? [...updatedFilteredRows, newRow]
                : updatedFilteredRows,
        focusNoteId:
            newRow != null
                ? newRow.ctx.notes[0].trackingId.toString()
                : state.focusNoteId,
    };
}
